import { Col, Form as BSForm, Row } from 'react-bootstrap';
import SigniteToggle from '../../../../ui-elements/toggle-switch/signiteToggleSwitch';
import { FieldArray } from 'formik';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';

export const PromotionsForm = ({ handleChange, values, handleBlur, errors, touched }) => {
  return (
    <div className="signite-form">
      <Row>
        <BSForm.Group as={Col} controlId="hasGotPromotions">
          <BSForm.Label>Any Promotions you got during your career?</BSForm.Label>
          <SigniteToggle
            id={'hasGotPromotions'}
            dataYes={'Yes'}
            dataNo={'No'}
            fieldInput={{
              onChange: handleChange,
              value: values.hasGotPromotions,
            }}
          />
        </BSForm.Group>
      </Row>

      {values.hasGotPromotions && (
        <FieldArray name="careerPromotions">
          {({ remove, push }) => (
            <>
              {values.careerPromotions &&
                values.careerPromotions.length > 0 &&
                values.careerPromotions.map((promotion, index) => (
                  <Row className="mb-3" key={index}>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Previous Designation</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`careerPromotions.${index}.previousDesignation`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={promotion.previousDesignation}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `careerPromotions.${index}.previousDesignation`
                        )}`}
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `careerPromotions.${index}.previousDesignation`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Promotion Year</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name={`careerPromotions.${index}.promotionYear`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={promotion.promotionYear}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `careerPromotions.${index}.promotionYear`
                        )}`}
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `careerPromotions.${index}.promotionYear`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} className="d-flex align-items-center">
                      <LinkButton
                        label="Remove Promotion"
                        onClick={() => remove(index)}
                        icon={faMinusCircle}
                      ></LinkButton>
                    </BSForm.Group>
                  </Row>
                ))}
              <Row className="mb-3">
                <Col>
                  <LinkButton
                    label="Add Promotions"
                    onClick={() =>
                      push({
                        previousDesignation: '',
                        promotionYear: '',
                      })
                    }
                  ></LinkButton>
                </Col>
              </Row>
            </>
          )}
        </FieldArray>
      )}
    </div>
  );
};